import { Observer, observer } from 'mobx-react-lite';
import React from 'react';
import { LYGEntryGeneralInfoModel } from 'src/lyg/pages/entries/shared/LYGEntryGeneralInfoModel';
import { FormFieldWrapper } from 'src/shared/ui/inputs/FormFieldWrapper';
import { DropdownField } from 'src/shared/ui/inputs/dropdown/DropdownField';
import { TextField } from 'src/shared/ui/inputs/text/TextField';
import { BoroughPicker } from 'src/lyg/features/boroughPicker';
import { useLYGEntriesQuery } from 'src/lyg/pages/entries/home/getEntriesQuery';
import { LYG_EVENT_TYPE } from 'src/lyg/entities/events';

interface QuestionsStepProps {
  model: LYGEntryGeneralInfoModel;
  showBoroughPicker: boolean;
  competitionId?: number;
}

export const LYGEntryQuestionsStep: React.FC<QuestionsStepProps> = observer(
  ({ model, showBoroughPicker = true, competitionId }) => {
    // const { currentUser } = useAuthContext();

    // React.useEffect(() => {
    //   model.setDefaultValues(null, currentUser.boroughId);
    // }, [currentUser.boroughId, model]);

    const openGamesQuery = useLYGEntriesQuery({
      page: 1,
      itemsPerPage: 350,
      eventType: LYG_EVENT_TYPE.openGames,
      competitionId: competitionId || undefined,
    });

    React.useEffect(() => {
      if (!competitionId) return;
      if (openGamesQuery.data && model.boroughPicker.value.id) {
        model.updateParticipantCountsFromGames(openGamesQuery.data?.entries);
      }
    }, [competitionId, model, model.boroughPicker.value.id, openGamesQuery.data]);

    return (
      <Observer>
        {() => (
          <>
            {showBoroughPicker && (
              <FormFieldWrapper model={model.boroughPicker}>
                <BoroughPicker model={model.boroughPicker} />
              </FormFieldWrapper>
            )}
            <>
              <FormFieldWrapper model={model.howSelectSquad}>
                <DropdownField model={model.howSelectSquad} />
              </FormFieldWrapper>

              <p
                style={{
                  color: '#06050fbf',
                  fontSize: '0.938rem',
                }}
              >
                Enter the number of participants to your selection:{' '}
                <span aria-label='Required field' className='fw-bolder ms-1 ts-color-primary'>
                  *
                </span>
              </p>

              <div className='d-flex gap-2 flex-nowrap'>
                <FormFieldWrapper model={model.totalBoysParticipants} className='w-100 flex-grow-1'>
                  <TextField model={model.totalBoysParticipants} />
                </FormFieldWrapper>
                <FormFieldWrapper model={model.totalGirlsParticipants} className='w-100 flex-grow-1'>
                  <TextField model={model.totalGirlsParticipants} />
                </FormFieldWrapper>
              </div>
              <div className='d-flex gap-2 flex-nowrap'>
                <FormFieldWrapper model={model.totalNonBinaryParticipants} className='w-100 flex-grow-1'>
                  <TextField model={model.totalNonBinaryParticipants} />
                </FormFieldWrapper>
                <FormFieldWrapper model={model.totalOtherParticipants} className='w-100 flex-grow-1'>
                  <TextField model={model.totalOtherParticipants} />
                </FormFieldWrapper>
              </div>
              <div className='d-flex gap-2 flex-nowrap'>
                <FormFieldWrapper model={model.totalNoResponseParticipants} className='w-100 flex-grow-1'>
                  <TextField model={model.totalNoResponseParticipants} />
                </FormFieldWrapper>
              </div>
            </>
          </>
        )}
      </Observer>
    );
  },
);
